import type { Middleware } from '@nuxt/types';

const currentABTestName: string = '';

const abTestMiddleware: Middleware = ({ $auth, $api, store, $analytics, route }) => {
  if ($auth.loggedIn) {
    if (
      !['war-room-posts', 'war-room-categories-categorySlug-posts', 'war-room-topics-topicSlug-posts'].includes(
        route.name || '',
      )
    ) {
      return;
    }

    let userABTestBranch;

    if (currentABTestName && !$auth.user.abTests![currentABTestName]) {
      userABTestBranch = Math.random() < 0.5 ? 'a' : 'b';

      // send request but do not await for it not to block route navigation
      $api.$put('/users/current/add_ab_test.json', {
        ab_test: { name: currentABTestName, branch: userABTestBranch },
      });

      const userABTestPropName = currentABTestName.replace(/^ab-test-(\d)/, 'ab_user__$1');

      if (process.server) {
        store.commit('enableShouldSetAmplitudeUserProperties');
      } else {
        $analytics?.setAmplitudeUserProperties({ [userABTestPropName]: userABTestBranch });
      }
    }

    const abTestBranchNameFromQuery = route.query[currentABTestName];

    if (abTestBranchNameFromQuery || userABTestBranch) {
      $auth.$storage.setState('user', {
        ...$auth.user,
        abTests: { ...$auth.user.abTests, [currentABTestName]: abTestBranchNameFromQuery || userABTestBranch },
      });
    }
  }
};

export default abTestMiddleware;
